'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'balloons';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M163.2 329.6c0 0 0 0 0 0l.7-.6c.7-.5 1.8-1.4 3.3-2.6c3-2.4 7.4-6.1 12.7-10.9c10.8-9.7 25.1-23.6 39.3-40.4C249.1 239.7 272 198.7 272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 38.7 22.9 79.7 52.7 115.1c14.2 16.9 28.5 30.8 39.3 40.4c5.4 4.8 9.8 8.5 12.7 10.9c1.5 1.2 2.6 2.1 3.3 2.6l.7 .6c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L160 332l3.1-2.3s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0zM128 368s-128-96-128-208C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 208-128 208l12.8 32L224 448l-51.7 0-24.6 0L96 448l19.2-48L128 368zm48-232c-22.1 0-40 17.9-40 40l-48 0c0-48.6 39.4-88 88-88l0 48zm176 24c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 112-128 208-128 208l12.8 32L544 512l-51.7 0-24.6 0L416 512l19.2-48L448 432s-100.3-75.2-123.3-170.1C340.6 231.6 352 197 352 160zM483.2 393.6l.7-.6c.7-.5 1.8-1.4 3.3-2.6c3-2.4 7.4-6.1 12.7-10.9c10.8-9.7 25.1-23.6 39.3-40.4C569.1 303.7 592 262.7 592 224c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 38.7 22.9 79.7 52.7 115.1c14.2 16.9 28.5 30.8 39.3 40.4c5.4 4.8 9.8 8.5 12.7 10.9c1.5 1.2 2.6 2.1 3.3 2.6l.7 .6c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L480 396l3.1-2.3s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0zM456 240l-48 0c0-48.6 39.4-88 88-88l0 48c-22.1 0-40 17.9-40 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;